import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { SubscriptionStore } from '../stores/subscription-store';

export const subscriptionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const nav = router.currentNavigation();

  if (!inject(AuthenticationService).isUserLoggedIn()) {
    return router.parseUrl('/login' + (nav?.finalUrl ? `?redirect=${nav.finalUrl.toString()}` : ''));
  }

  if (inject(SubscriptionStore).isSubscribed()) {
    return true;
  }
  return router.navigate(['/packages']);
};
